import React from "react";
import Link from "next/link";

function Header() {
    return (
        <header
            className="fixed left-0 z-50 w-full h-[56px] md:h-[30px] md:w-[770px] lg:w-full bg-[#1275ba] text-white flex items-center justify-center shadow-md"
            style={{ top: "var(--banner-height, 0px)" }}
        >
            <div className="flex justify-center items-center w-full max-w-[1380px] px-4 md:px-8">
                <a
                    href="#main-content"
                    className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-md focus:bg-white focus:px-3 focus:py-2 focus:text-[#1275ba]"
                >
                    Skip to main content
                </a>
                <div className="bg-transparent flex flex-col justify-between items-center gap-2 h-auto w-[300px] text-[15px] md:gap-0 md:w-[600px] lg:w-[900px] xl:w-[1380px] md:h-[26px] md:flex-row md:justify-end md:space-x-8">
                    <nav aria-label="Primary">
                        <ul className="list-none flex gap-6 justify-evenly w-full md:w-auto md:justify-end md:space-x-8">
                            <li className="whitespace-nowrap flex items-center">
                                <i className="fa fa-address-card mr-[5px]" aria-hidden="true"></i>
                                <Link href="/apply-now" aria-label="Apply Now" className="hover:underline">
                                    APPLY NOW
                                </Link>
                            </li>
                            <li className="whitespace-nowrap flex items-center">
                                <i className="fa fa-phone mr-[5px]" aria-hidden="true"></i>
                                <Link href="/contact" aria-label="Contact Us" className="hover:underline">
                                    CONTACT US
                                </Link>
                            </li>
                            <li className="whitespace-nowrap hidden">
                                <i className="fa fa-lock mr-[5px]" aria-hidden="true"></i>
                                <Link href="/client-login" className="hover:underline">
                                    CLIENT LOGIN
                                </Link>
                            </li>
                        </ul>
                    </nav>
                    <div className="mb-[2px] md:mb-0" aria-hidden="true">
                        <span className="whitespace-nowrap flex items-center justify-center">
                            <i className="fa fa-lock mr-[5px]" aria-hidden="true"></i>
                            <Link href="/client-login" className="hover:underline" tabIndex={-1}>
                                CLIENT LOGIN
                            </Link>
                        </span>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
